module.exports = __webpack_public_path__ + "img/1523698382.9418fd33.jpg";